module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_jg3-02034d553959e5fe8adcbc2864753b37.png";